import { Component, HostBinding, Input } from '@angular/core';
import { Theme } from 'studio-components';

@Component({
  selector: 'studio-form-subtext',
  templateUrl: './form-subtext.component.html',
  styleUrls: ['./form-subtext.component.scss'],
})
export class FormSubtextComponent {
  @HostBinding('class')
  @Input()
  theme: Theme = 'light';
}
